import { useQuery } from '@apollo/client'
import { getPage as getPageGql } from 'src/graphql/queries/getPage.gql'

const usePage = (variables, options = {}) => {
   const { data, error, networkStatus, refetch, loading } = useQuery(getPageGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...options
   })

   const hasFatalErrors = error?.networkError ||
      error?.graphQLErrors?.some(err => err?.extensions?.exception?.name !== 'NonFatal')

   if (hasFatalErrors) {
      throw error
   }

   return {
      page: data?.page,
      error,
      loading,
      networkStatus,
      refetch
   }
}

export default usePage
